<div class="page-container">
    <mat-card class="card designs-card">
        <mat-card-content>
            <p i18n  class="mat-card-header">Select date</p>
            <div class="content">
                <div class="column-container title-column-container">
                    <th class="title-column" i18n>Date</th>
                    <th class="title-column" i18n>Title</th>
                    <th class="title-column" i18n>Language</th>
                    <th class="title-column" i18n>Platform</th>
                    <th class="title-column" i18n>Spots left</th>
                    <th class="title-column" i18n></th>
                </div>
                <div class="column-container" *ngFor="let session of sessions">
                    <td class="title-column" i18n>{{session.date | date:'yyyy-MM-dd HH:mm'}}</td>
                    <td class="title-column" i18n>{{session.title}}</td>
                    <td class="title-column" i18n>{{session.language}}</td>
                    <td class="title-column" i18n>{{session.platform}}</td>
                    <td class="title-column" i18n>{{20 - session.bookings}}/20</td>
                    <td class="title-column" i18n><button (click)="addReservation(session)" class="reserve-button" [disabled]="session.bookings > 20 || session.userreserved">Reserve</button></td>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>